import styled from "styled-components";

export const HeaderPhoneModalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme?.spacing?.x2 || "8px"};
  width: 100%;
`;

export const PhoneItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme?.spacing?.x2 || "8px"};
  max-height: 428px;
  overflow-y: auto;
  padding: 0 0 ${({ theme }) => theme?.spacing?.x1 || "4px"} 0;
  scrollbar-gutter: stable;
`;

export const PhoneItemContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  padding: 8px;
  min-height: 56px;
  border-radius: 8px;
  margin-bottom: 4px;

  border: 1px solid
    ${({ hasError, isValid, isEditing, theme }) => {
      if (!isEditing) return theme?.colors?.davysGrey;
      if (hasError) return theme?.colors?.errorDark || theme?.colors?.redOxide;
      if (isValid) return theme?.colors?.successGreen;
      return theme?.colors?.davysGrey;
    }};
`;

export const SideIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  margin-top: auto;
  margin-bottom: auto;
  cursor: pointer;
`;

export const AddPhoneContainer = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  border: 1px solid ${({ theme }) => theme?.colors?.davysGrey};
  background: ${({ theme }) => theme?.colors?.white};

  &:hover {
    background: ${({ theme }) => theme?.colors?.lightGrey};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

export const PhoneInputContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0;
  height: 40px;

  span {
    display: flex;
    align-items: center;
    height: 100%;
  }

  input,
  input:focus,
  input:active {
    width: 100%;
    border: none;
    outline: none;
    box-shadow: none;
    height: auto;
    padding: 0;
    color: ${({ theme }) => theme?.colors?.davysGrey};
  }
`;

export const RadioButton = styled.input`
  width: 16px;
  height: 16px;
  cursor: pointer;
`;

export const ValidationMessage = styled.div`
  font-size: 12px;
  font-weight: 400;
  margin-left: 16px;
  color: ${({ type, theme }) =>
    type === "error"
      ? theme?.colors?.errorDark || theme?.colors?.redOxide
      : theme?.colors?.successGreen};
`;

export const FloatingAlertContainer = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: auto;
  z-index: 2000;
  pointer-events: none;
`;
